// extracted by mini-css-extract-plugin
export default {"productGallery":"oJ-z","inQuickShop":"pJ-z"};